module.exports = __webpack_public_path__ + "static/media/12.9bfb3157.png";